const BRAZIL_COUNTRY_CODE = '55';

export function formatPhone(tel: string) {
    if (!tel) {
        return tel;
    }
    let onlyNumbers = tel.replace(/\D/g, '');

    // Gravado em E.164 (5511999998888): o DDI sai antes de formatar com a máscara brasileira.
    if (onlyNumbers.length > 11 && onlyNumbers.startsWith(BRAZIL_COUNTRY_CODE)) {
        onlyNumbers = onlyNumbers.slice(BRAZIL_COUNTRY_CODE.length);
    }

    if (onlyNumbers.length === 11) {
        return onlyNumbers.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    } else if (onlyNumbers.length === 10) {
        return onlyNumbers.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    } else if (onlyNumbers.length === 8) {
        return onlyNumbers.replace(/(\d{4})(\d{4})/, '$1-$2');
    } else {
        return tel;
    }
}
